"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const bn_js_1 = __importDefault(require("bn.js"));
const hash_js_1 = __importDefault(require("hash.js"));
const assert_1 = __importDefault(require("assert"));
const RSV = __importStar(require("rsv-signature"));
const elliptic = __importStar(require("elliptic"));
const keccak256_1 = __importDefault(require("keccak256"));
const web3_utils_1 = require("web3-utils");
const enc_utils_1 = require("enc-utils");
const constants_1 = require("./constants");
const asset_1 = require("./asset");
function solidityKeccak(types, values) {
    const input = types.map((type, i) => {
        let value = values[i];
        if (Buffer.isBuffer(value)) {
            value = enc_utils_1.sanitizeHex(value.toString('hex'));
        }
        return {
            type,
            value,
        };
    });
    return enc_utils_1.hexToBuffer(web3_utils_1.soliditySha3(...input).slice(2));
}
exports.solidityKeccak = solidityKeccak;
function intToBN(value) {
    return new bn_js_1.default(value || 0, 10);
}
exports.intToBN = intToBN;
function hexToBN(value) {
    if (typeof value === 'number') {
        return new bn_js_1.default(value, 10);
    }
    else if (typeof value === 'string') {
        if (isHexPrefixed(value)) {
            return new bn_js_1.default(enc_utils_1.removeHexPrefix(value), 16);
        }
        else if (isHexString(value)) {
            return new bn_js_1.default(value, 16);
        }
        else {
            return new bn_js_1.default(value, 10);
        }
    }
    return value;
}
exports.hexToBN = hexToBN;
function isHexPrefixed(str) {
    return (str || '').substring(0, 2) === '0x';
}
exports.isHexPrefixed = isHexPrefixed;
function hasHexPrefix(str) {
    return (str || '').substring(0, 2) === '0x';
}
exports.hasHexPrefix = hasHexPrefix;
function isHexString(str) {
    return /[a-fA-F0-9]+$/.test(str.replace(/\s+/gi, ''));
}
exports.isHexString = isHexString;
exports.PRIME = hexToBN('800000000000011000000000000000000000000000000000000000000000001');
exports.maxEcdsaVal = hexToBN('800000000000000000000000000000000000000000000000000000000000000');
exports.order = hexToBN('08000000 00000010 ffffffff ffffffff b781126d cae7b232 1e66a241 adc64d2f');
exports.secpOrder = hexToBN('FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFE BAAEDCE6 AF48A03B BFD25E8C D0364141');
const starkEc = new elliptic.ec(new elliptic.curves.PresetCurve({
    type: 'short',
    prime: null,
    p: exports.PRIME,
    a: '00000000 00000000 00000000 00000000 00000000 00000000 00000000 00000001',
    b: '06f21413 efbe40de 150e596d 72f7a8c5 609ad26c 15c915c1 f4cdfcb9 9cee9e89',
    n: exports.order,
    hash: hash_js_1.default.sha256,
    gRed: false,
    g: constants_1.constantPointsHex[1],
}));
exports.ec = starkEc;
exports.constantPoints = constants_1.constantPointsHex.map((coords) => starkEc.curve.point(hexToBN(coords[0]), hexToBN(coords[1])));
exports.shiftPoint = exports.constantPoints[0];
exports.ZERO_BN = intToBN('0');
exports.ONE_BN = intToBN('1');
exports.TWO_BN = intToBN('2');
exports.TWO_POW_22_BN = hexToBN('400000');
exports.TWO_POW_31_BN = hexToBN('80000000');
exports.TWO_POW_63_BN = hexToBN('8000000000000000');
const MISSING_HEX_PREFIX = 'Hex strings expected to be prefixed with 0x.';
function pedersen(input) {
    let point = exports.shiftPoint;
    for (let i = 0; i < input.length; i++) {
        let x = hexToBN(input[i]);
        assert_1.default(x.gte(exports.ZERO_BN) && x.lt(exports.PRIME), 'Invalid input: ' + input[i]);
        for (let j = 0; j < 252; j++) {
            const pt = exports.constantPoints[2 + i * 252 + j];
            assert_1.default(!point.getX().eq(pt.getX()));
            if (x.and(exports.ONE_BN).toNumber() !== 0) {
                point = point.add(pt);
            }
            x = x.shrn(1);
        }
    }
    return point.getX().toString(16);
}
exports.pedersen = pedersen;
function isCompressedPublicKey(hex) {
    hex = enc_utils_1.removeHexPrefix(hex);
    return hex.length === 66 && (hex.startsWith('03') || hex.startsWith('02'));
}
function checkHexValue(hex) {
    assert_1.default(isHexPrefixed(hex), MISSING_HEX_PREFIX);
    const hexBn = hexToBN(hex);
    assert_1.default(hexBn.gte(exports.ZERO_BN));
    assert_1.default(hexBn.lt(exports.PRIME));
}
function parseTokenInput(input) {
    if (typeof input === 'string') {
        if (isCompressedPublicKey(input)) {
            return getXCoordinate(input);
        }
        console.debug('parseTokenInput', input);
        checkHexValue(input);
        return input;
    }
    return asset_1.getAssetId(input);
}
function fixMessage(msg) {
    msg = enc_utils_1.removeHexPrefix(msg);
    msg = hexToBN(msg).toString(16);
    if (msg.length <= 62) {
        return msg;
    }
    assert_1.default(msg.length === 63);
    return msg + '0';
}
function hashSelector(selector) {
    return enc_utils_1.sanitizeHex(keccak256_1.default(selector)
        .toString('hex')
        .slice(0, 8));
}
function assertInRange(input, lowerBound, upperBound, inputName = '') {
    const messageSuffix = inputName === '' ? 'invalid length' : `invalid ${inputName} length`;
    assert_1.default(input.gte(lowerBound) && input.lt(upperBound), `Message not signable, ${messageSuffix}.`);
}
exports.assertInRange = assertInRange;
function getKeyPair(privateKey) {
    return starkEc.keyFromPrivate(privateKey, 'hex');
}
exports.getKeyPair = getKeyPair;
function getKeyPairFromPublicKey(publicKey) {
    return starkEc.keyFromPublic(enc_utils_1.hexToArray(publicKey));
}
exports.getKeyPairFromPublicKey = getKeyPairFromPublicKey;
function getKeyPairFromStarkPublicKey(starkPublicKey) {
    return starkEc.keyFromPublic(enc_utils_1.hexToArray(starkPublicKey));
}
exports.getKeyPairFromStarkPublicKey = getKeyPairFromStarkPublicKey;
function getPrivate(keyPair) {
    return keyPair.getPrivate('hex');
}
exports.getPrivate = getPrivate;
function getPublic(keyPair, compressed = false) {
    return keyPair.getPublic(compressed, 'hex');
}
exports.getPublic = getPublic;
function getStarkPublicKey(keyPair) {
    return getPublic(keyPair, true);
}
exports.getStarkPublicKey = getStarkPublicKey;
function getStarkKey(keyPair) {
    return enc_utils_1.sanitizeBytes(keyPair.pub.getX().toString(16), 2);
}
exports.getStarkKey = getStarkKey;
function getXCoordinate(publicKey) {
    const keyPair = getKeyPairFromPublicKey(publicKey);
    return enc_utils_1.sanitizeBytes(keyPair.pub.getX().toString(16), 2);
}
exports.getXCoordinate = getXCoordinate;
function getYCoordinate(publicKey) {
    const keyPair = getKeyPairFromPublicKey(publicKey);
    return enc_utils_1.sanitizeBytes(keyPair.pub.getY().toString(16), 2);
}
exports.getYCoordinate = getYCoordinate;
exports.ETH_SELECTOR = hashSelector('ETH()');
exports.ERC20_SELECTOR = hashSelector('ERC20Token(address)');
exports.ERC721_SELECTOR = hashSelector('ERC721Token(address,uint256)');
exports.MINTABLE_ERC20_SELECTOR = hashSelector('MintableERC20Token(address)');
exports.MINTABLE_ERC721_SELECTOR = hashSelector('MintableERC721Token(address,uint256)');
exports.NFT_ASSET_ID_PREFIX = 'NFT:';
exports.MINTABLE_ASSET_ID_PREFIX = 'MINTABLE:';
exports.MASK_250_BITS_BN = hexToBN('03FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF');
exports.MASK_240_BITS_BN = hexToBN('FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF');
exports.MINTABLE_ASSET_ID_FLAG = hexToBN('400000000000000000000000000000000000000000000000000000000000000');
function getAssetInfo(contractAddress, tokenSelector) {
    return getAssetInfoFromAddress(contractAddress, tokenSelector);
}
exports.getAssetInfo = getAssetInfo;
function getAssetInfoFromAddress(tokenAddress, selector) {
    const buf = Buffer.alloc(32);
    const addrBuf = enc_utils_1.hexToBuffer(tokenAddress);
    addrBuf.copy(buf, buf.length - addrBuf.length);
    const assetInfo = selector + buf.toString('hex');
    return assetInfo;
}
exports.getAssetInfoFromAddress = getAssetInfoFromAddress;
function calculateAssetType(assetInfo, quantum = '1') {
    const h = solidityKeccak(['bytes', 'uint256'], [assetInfo, quantum]);
    const bn = hexToBN(h.toString('hex'));
    return enc_utils_1.sanitizeHex(bn.and(exports.MASK_250_BITS_BN).toString(16));
}
exports.calculateAssetType = calculateAssetType;
function calculateMintableAssetId(mintableContractAddress, selector, mintingBlob, quantum = '1') {
    const assetInfo = getAssetInfo(mintableContractAddress, selector);
    const assetType = calculateAssetType(assetInfo, quantum);
    const blobHash = solidityKeccak(['bytes'], [mintingBlob]);
    const interimHash = solidityKeccak(['string', 'uint256', 'uint256'], [exports.MINTABLE_ASSET_ID_PREFIX, assetType, blobHash]);
    const bn = hexToBN(interimHash.toString('hex'));
    return enc_utils_1.sanitizeHex(bn
        .and(exports.MASK_240_BITS_BN)
        .or(exports.MINTABLE_ASSET_ID_FLAG)
        .toString(16));
}
exports.calculateMintableAssetId = calculateMintableAssetId;
function getAddressFromAssetInfo(assetInfo, selector = exports.ERC20_SELECTOR) {
    const assetInfoBuf = enc_utils_1.hexToBuffer(assetInfo);
    const selectorBuf = enc_utils_1.hexToBuffer(selector);
    assert_1.default(selectorBuf.byteLength === 4);
    const addressLength = 20;
    const paddingLength = 32 - addressLength;
    assert_1.default(Buffer.compare(assetInfoBuf.slice(0, 4 + paddingLength), Buffer.concat([selectorBuf, Buffer.alloc(paddingLength)])) === 0);
    return enc_utils_1.sanitizeHex(assetInfoBuf.slice(4 + paddingLength).toString('hex'));
}
exports.getAddressFromAssetInfo = getAddressFromAssetInfo;
function getEthAssetType(quantum) {
    const assetInfo = exports.ETH_SELECTOR;
    return calculateAssetType(assetInfo, quantum);
}
exports.getEthAssetType = getEthAssetType;
function getErc20AssetType(erc20ContractAddress, quantum) {
    const assetInfo = getAssetInfo(erc20ContractAddress, exports.ERC20_SELECTOR);
    return calculateAssetType(assetInfo, quantum);
}
exports.getErc20AssetType = getErc20AssetType;
function getErc721AssetType(erc721ContractAddress) {
    const assetInfo = getAssetInfo(erc721ContractAddress, exports.ERC721_SELECTOR);
    return calculateAssetType(assetInfo, '1');
}
exports.getErc721AssetType = getErc721AssetType;
function getMintableErc20AssetType(mintableErc20ContractAddress, quantum) {
    const assetInfo = getAssetInfo(mintableErc20ContractAddress, exports.MINTABLE_ERC20_SELECTOR);
    return calculateAssetType(assetInfo, quantum);
}
exports.getMintableErc20AssetType = getMintableErc20AssetType;
function getMintableErc721AssetType(mintableErc721ContractAddress) {
    const assetInfo = getAssetInfo(mintableErc721ContractAddress, exports.MINTABLE_ERC721_SELECTOR);
    return calculateAssetType(assetInfo, '1');
}
exports.getMintableErc721AssetType = getMintableErc721AssetType;
function hashMessage(wordsOrW1, w2, w3) {
    if (typeof wordsOrW1 === 'string' && w2 && w3) {
        return pedersen([pedersen([wordsOrW1, w2]), w3]);
    }
    let a = wordsOrW1[0];
    let b = wordsOrW1[1];
    if (Array.isArray(a)) {
        a = hashMessage(a);
    }
    if (Array.isArray(b)) {
        b = hashMessage(b);
    }
    return pedersen([a, b]);
}
exports.hashMessage = hashMessage;
function deserializeMessage(serialized) {
    serialized = enc_utils_1.removeHexPrefix(serialized);
    const slice0 = 0;
    const slice1 = slice0 + 1;
    const slice2 = slice1 + 31;
    const slice3 = slice2 + 31;
    const slice4 = slice3 + 63;
    const slice5 = slice4 + 63;
    const slice6 = slice5 + 31;
    const slice7 = slice6 + 22;
    return {
        instructionTypeBn: hexToBN(serialized.substring(slice0, slice1)),
        vault0Bn: hexToBN(serialized.substring(slice1, slice2)),
        vault1Bn: hexToBN(serialized.substring(slice2, slice3)),
        amount0Bn: hexToBN(serialized.substring(slice3, slice4)),
        amount1Bn: hexToBN(serialized.substring(slice4, slice5)),
        nonceBn: hexToBN(serialized.substring(slice5, slice6)),
        expirationTimestampBn: intToBN(serialized.substring(slice6, slice7)),
    };
}
exports.deserializeMessage = deserializeMessage;
function serializeMessage(instructionTypeBn, vault0Bn, vault1Bn, amount0Bn, amount1Bn, nonceBn, expirationTimestampBn) {
    let serialized = instructionTypeBn;
    serialized = serialized.ushln(31).add(vault0Bn);
    serialized = serialized.ushln(31).add(vault1Bn);
    serialized = serialized.ushln(63).add(amount0Bn);
    serialized = serialized.ushln(63).add(amount1Bn);
    serialized = serialized.ushln(31).add(nonceBn);
    serialized = serialized.ushln(22).add(expirationTimestampBn);
    return enc_utils_1.sanitizeHex(serialized.toString(16));
}
exports.serializeMessage = serializeMessage;
function formatMessage(instruction, vault0, vault1, amount0, amount1, nonce, expirationTimestamp) {
    const instructionTypeBNs = {
        order: exports.ZERO_BN,
        transfer: exports.ONE_BN,
        conditionalTransfer: exports.TWO_BN,
    };
    const isTransfer = instruction === 'transfer' || instruction === 'conditionalTransfer';
    const vault0Bn = intToBN(vault0);
    const vault1Bn = intToBN(vault1);
    const amount0Bn = intToBN(amount0);
    const amount1Bn = intToBN(amount1);
    const nonceBn = intToBN(nonce);
    const expirationTimestampBn = intToBN(expirationTimestamp);
    assert_1.default(vault0Bn.gte(exports.ZERO_BN));
    assert_1.default(vault1Bn.gte(exports.ZERO_BN));
    assert_1.default(amount0Bn.gte(exports.ZERO_BN));
    if (!isTransfer) {
        assert_1.default(amount1Bn.gte(exports.ZERO_BN));
    }
    assert_1.default(nonceBn.gte(exports.ZERO_BN));
    assert_1.default(expirationTimestampBn.gte(exports.ZERO_BN));
    assert_1.default(vault0Bn.lt(exports.TWO_POW_31_BN));
    assert_1.default(vault1Bn.lt(exports.TWO_POW_31_BN));
    assert_1.default(amount0Bn.lt(exports.TWO_POW_63_BN));
    assert_1.default(amount1Bn.lt(exports.TWO_POW_63_BN));
    assert_1.default(nonceBn.lt(exports.TWO_POW_31_BN));
    assert_1.default(expirationTimestampBn.lt(exports.TWO_POW_22_BN));
    const instructionTypeBn = instructionTypeBNs[instruction];
    return serializeMessage(instructionTypeBn, vault0Bn, vault1Bn, amount0Bn, amount1Bn, nonceBn, expirationTimestampBn);
}
exports.formatMessage = formatMessage;
function getLimitOrderMsgHash(sellVaultId, buyVaultId, sellQuantizedAmount, buyQuantizedAmount, sellAsset, buyAsset, nonce, expirationTimestamp) {
    const w1 = parseTokenInput(sellAsset);
    const w2 = parseTokenInput(buyAsset);
    const w3 = formatMessage('order', sellVaultId, buyVaultId, sellQuantizedAmount, buyQuantizedAmount, nonce, expirationTimestamp);
    const sellVaultIdBn = intToBN(sellVaultId);
    const buyVaultIdBn = intToBN(buyVaultId);
    const sellQuantizedAmountBn = intToBN(sellQuantizedAmount);
    const buyQuantizedAmountBn = intToBN(buyQuantizedAmount);
    const sellAssetBn = hexToBN(w1.substring(2));
    const buyAssetBn = hexToBN(w2.substring(2));
    const nonceBn = intToBN(nonce);
    const expirationTimestampBn = intToBN(expirationTimestamp);
    assertInRange(sellVaultIdBn, exports.ZERO_BN, exports.TWO_POW_31_BN, 'sellVaultId');
    assertInRange(buyVaultIdBn, exports.ZERO_BN, exports.TWO_POW_31_BN, 'buyVaultId');
    assertInRange(sellQuantizedAmountBn, exports.ZERO_BN, exports.TWO_POW_63_BN, 'sellQuantizedAmount');
    assertInRange(buyQuantizedAmountBn, exports.ZERO_BN, exports.TWO_POW_63_BN, 'buyQuantizedAmount');
    assertInRange(sellAssetBn, exports.ZERO_BN, exports.PRIME, 'sellAsset');
    assertInRange(buyAssetBn, exports.ZERO_BN, exports.PRIME, 'buyAsset');
    assertInRange(nonceBn, exports.ZERO_BN, exports.TWO_POW_31_BN, 'nonce');
    assertInRange(expirationTimestampBn, exports.ZERO_BN, exports.TWO_POW_22_BN, 'expirationTimestamp');
    const msgHash = hashMessage([[w1, w2], w3]);
    const msgHashBN = hexToBN(msgHash);
    assertInRange(msgHashBN, exports.ZERO_BN, exports.maxEcdsaVal, 'msgHash');
    return enc_utils_1.sanitizeHex(msgHash);
}
exports.getLimitOrderMsgHash = getLimitOrderMsgHash;
function getTransferMsgHash(quantizedAmount, nonce, senderVaultId, token, targetVaultId, targetPublicKey, expirationTimestamp, condition = null) {
    assert_1.default(hasHexPrefix(targetPublicKey) && (!condition || hasHexPrefix(condition)), MISSING_HEX_PREFIX);
    const w1 = parseTokenInput(token);
    const w2 = parseTokenInput(targetPublicKey);
    const w3 = formatMessage(condition ? 'conditionalTransfer' : 'transfer', senderVaultId, targetVaultId, quantizedAmount, exports.ZERO_BN.toString(), nonce, expirationTimestamp);
    const quantizedAmountBn = intToBN(quantizedAmount);
    const nonceBn = intToBN(nonce);
    const senderVaultIdBn = intToBN(senderVaultId);
    const tokenBn = hexToBN(w1.substring(2));
    const targetVaultIdBn = intToBN(targetVaultId);
    const targetPublicKeyBn = hexToBN(targetPublicKey.substring(2));
    const expirationTimestampBn = intToBN(expirationTimestamp);
    assertInRange(quantizedAmountBn, exports.ZERO_BN, exports.TWO_POW_63_BN, 'quantizedAmount');
    assertInRange(nonceBn, exports.ZERO_BN, exports.TWO_POW_31_BN, 'nonce');
    assertInRange(senderVaultIdBn, exports.ZERO_BN, exports.TWO_POW_31_BN, 'senderVault');
    assertInRange(tokenBn, exports.ZERO_BN, exports.PRIME, 'token');
    assertInRange(targetVaultIdBn, exports.ZERO_BN, exports.TWO_POW_31_BN, 'targetVaultId');
    assertInRange(targetPublicKeyBn, exports.ZERO_BN, exports.PRIME, 'targetPublicKey');
    assertInRange(expirationTimestampBn, exports.ZERO_BN, exports.TWO_POW_22_BN, 'expirationTimestamp');
    if (condition) {
        const w4 = condition;
        const msgHash = hashMessage([[[w1, w2], w4], w3]);
        const msgHashBN = hexToBN(msgHash);
        assertInRange(msgHashBN, exports.ZERO_BN, exports.maxEcdsaVal, 'msgHash');
        return enc_utils_1.sanitizeHex(msgHash);
    }
    const msgHash = hashMessage([[w1, w2], w3]);
    const msgHashBN = hexToBN(msgHash);
    assertInRange(msgHashBN, exports.ZERO_BN, exports.maxEcdsaVal, 'msgHash');
    return enc_utils_1.sanitizeHex(msgHash);
}
exports.getTransferMsgHash = getTransferMsgHash;
function sign(keyPair, msgHash) {
    const msgHashBN = hexToBN(msgHash);
    assertInRange(msgHashBN, exports.ZERO_BN, exports.maxEcdsaVal, 'msgHash');
    const msgSignature = keyPair.sign(fixMessage(msgHash));
    const { r, s } = msgSignature;
    const w = s.invm(starkEc.n);
    assertInRange(r, exports.ONE_BN, exports.maxEcdsaVal, 'r');
    assertInRange(s, exports.ONE_BN, starkEc.n, 's');
    assertInRange(w, exports.ONE_BN, exports.maxEcdsaVal, 'w');
    return msgSignature;
}
exports.sign = sign;
function verify(keyPair, msgHash, sig) {
    const msgHashBN = hexToBN(msgHash);
    assertInRange(msgHashBN, exports.ZERO_BN, exports.maxEcdsaVal, 'msgHash');
    const { r, s } = sig;
    const w = s.invm(starkEc.n);
    assertInRange(r, exports.ONE_BN, exports.maxEcdsaVal, 'r');
    assertInRange(s, exports.ONE_BN, starkEc.n, 's');
    assertInRange(w, exports.ONE_BN, exports.maxEcdsaVal, 'w');
    return keyPair.verify(fixMessage(msgHash), sig);
}
exports.verify = verify;
function compress(publicKey) {
    return getKeyPairFromPublicKey(publicKey).getPublic(true, 'hex');
}
exports.compress = compress;
function decompress(publicKey) {
    return getKeyPairFromPublicKey(publicKey).getPublic(false, 'hex');
}
exports.decompress = decompress;
function verifyStarkPublicKey(starkPublicKey, msg, sig) {
    const keyPair = getKeyPairFromStarkPublicKey(starkPublicKey);
    return verify(keyPair, msg, sig);
}
exports.verifyStarkPublicKey = verifyStarkPublicKey;
exports.exportRecoveryParam = RSV.exportRecoveryParam;
exports.importRecoveryParam = RSV.importRecoveryParam;
exports.serializeSignature = RSV.serializeSignature;
exports.deserializeSignature = RSV.deserializeSignature;
exports.REGISTRATION_PREFIX = 'UserRegistration';
function createUserRegistrationSig(address, starkKey, signerKey) {
    const msgHash = solidityKeccak(['string', 'address', 'uint256'], [exports.REGISTRATION_PREFIX, address, starkKey]).toString('hex');
    const keyPair = getKeyPair(signerKey);
    const sig = keyPair.sign(msgHash);
    return exports.serializeSignature(sig);
}
exports.createUserRegistrationSig = createUserRegistrationSig;
exports.quantizeAmount = (amount, quantum) => {
    const quantizedAmount = intToBN(amount).div(intToBN(quantum));
    return quantizedAmount.toString();
};
//# sourceMappingURL=crypto.js.map